import React from "react";

const MessagesIcon = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.317"
    height="24.317"
    viewBox="0 0 24.317 24.317"
    fill={fill}
  >
    <g fill={fill} id="Group_174" data-name="Group 174" transform="translate(-4.936 0.995)">
      <path
        id="Path_75"
        data-name="Path 75"
        d="M7.82,22.706,2,24l1.294-5.82A10.994,10.994,0,1,1,7.82,22.706Z"
        transform="translate(4.253 -1.995)"
        fill="none"
        stroke={fill}
        strokeWidth="2"
      />
      <g fill={fill} id="Group_173" data-name="Group 173" transform="translate(12.253 9.894)">
        <circle
          id="Ellipse_20"
          data-name="Ellipse 20"
          cx="1.111"
          cy="1.111"
          r="1.111"
          transform="translate(0 0)"
          fill={fill}
        />
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="1.111"
          cy="1.111"
          r="1.111"
          transform="translate(3.889 0)"
          fill={fill}
        />
        <circle
          id="Ellipse_23"
          data-name="Ellipse 23"
          cx="1.111"
          cy="1.111"
          r="1.111"
          transform="translate(7.778 0)"
          fill={fill}
        />
      </g>
    </g>
  </svg>
);

export default MessagesIcon;
